import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DynamicFormContentDetails } from '../dynamic-form-content-details/dynamic-form-content-details.component';
import { PAGES } from '../../dynamic-details.constants';

@Component({
  selector: 'cm-draft-forms-content',
  templateUrl: './draft-forms-content.component.html',
  styleUrls: ['./draft-forms-content.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DraftFormsContentComponent {
  @Input() details: DynamicFormContentDetails;
  @Input() formQuantity: number;
  @Input() disabled = false;
  @Output() screenChange: EventEmitter<string> = new EventEmitter();
  @Output() formSubmit: EventEmitter<any> = new EventEmitter();

  PAGES = PAGES;

  constructor(private _modalService: NgbActiveModal) {}

  dismissModal() {
    this._modalService.dismiss();
  }

  submitForm() {
    this.formSubmit.emit();
  }
}
